import { combineReducers } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';
import { charitiesReducer } from '../components/charity/CharityOperations';
import { authReducer } from '../components/auth/';
import { donationsReducer } from '../components/donation/';
import { stripeConnectReducer } from '../components/stripe-connect';
import { campaignsReducer } from '../components/campaign';
import { placementsReducer } from '../components/placement';
import { homeReducer } from '../components/home/HomeComponent';
import { petitionReducer } from '../components/petition';
import { paypalConnectReducer } from '../components/paypal-connect';

const rootReducer = combineReducers({
  charities: charitiesReducer,
  campaigns: campaignsReducer,
  placements: placementsReducer,
  auth: authReducer,
  stripe: stripeConnectReducer,
  donations: donationsReducer,
  form: reduxFormReducer,
  home: homeReducer,
  petitions: petitionReducer,
  paypal: paypalConnectReducer
});

export default rootReducer;
